"use client";

import HcpAccordion from '@/components-hcp/accordion';
import styles from './_hcp-pharmacokinetic.module.scss';

export default function HcpDosingPharmacokinetic() {
  return (
    <section className={styles.container}>
      <HcpAccordion
        label={<>View pharmacokinetics</>}
      >
        <div className="container">
          <h2 className={`h1 ${styles.heading}`}>A pharmacokinetic profile that <br className="hidden tablet:block" />supports twice-daily dosing<sup>1</sup></h2>
          <div className={styles.content_wrapper}>
            <div className={styles.info_section}>
              <div className={styles.info_row}>
                <div className={styles.info_item}>
                  <div className={styles.left_side_image__wrapper}>
                    <p>Following oral administration, the time to reach maximum CRENESSITY plasma concentration is</p>
                    <h2 className={styles.h2}>4 hours<sup>1</sup></h2>
                  </div>
                </div>
                <div className={styles.info_item}>
                  <div className={styles.left_side_image__wrapper}>
                    <p>The effective half-life of <br />CRENESSITY is approximately</p>
                    <h2 className={styles.h2}>14 hours<sup>1</sup></h2>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.callout_wrapper}>
              <div className={`hcp-callout ${styles.dosing_pharmacokinetic_hcp_callout}`}>
                Efficacy and safety outcomes in the phase 3 trials are based on twice-daily dosing.<sup>1</sup>
              </div>
            </div>
          </div>
        </div>
      </HcpAccordion>
    </section>
  );
}
